import { RollbackOutlined } from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import { useFeedback } from '../../../hooks/useFeedback';
import { secureApi } from '../../../hooks/api';
import { url } from '../../../constants/api';
import { useCrudRecord } from '../../../containers/crud/recordContext';

export const ResetWebsiteConfigurations = () => {
  const { modal } = useFeedback();
  const { key } = useCrudRecord();
  const onConfirm = async () => {
    try {
      await secureApi(url(`websites/reset-config/${key}`), {
        method: 'POST',
      });
      message.success('Website configurations have been successfully reset.');
    } catch (error) {
      message.error(
        'Failed to reset website configurations. Please try again.'
      );
    }
  };
  return (
    <Tooltip title="Reset configurations" placement="bottom">
      <Button
        className="btn blue-btn-text"
        onClick={() => {
          modal.confirm({
            title: 'Are you sure you want to reset website configurations?',
            content:
              'This action cannot be undone. All configurations will be permanently reset.',
            onOk: onConfirm,
            okType: 'danger',
          });
        }}
      >
        <RollbackOutlined />
      </Button>
    </Tooltip>
  );
};
